import pancakeLandscapeImg from "../../../assets/img/pancake-landscape.png"
import pancakeLandscapeImgWebp from "../../../assets/img/pancake-landscape.webp"

const DiabeticCustomer = () => (
    <section id="dia-customer">
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center py-md-4 py-3">
                <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-md-start text-center order-md-1 order-2">
                    <h3 className="fw-bold mb-md-5 mb-3">Am I a type 2 diabetic… or am I a customer?</h3>
                    <p>In that moment, it hit me. I’d been unknowingly paying for a lifelong subscription I never signed up for.</p>
                    <p>Test strips. Insulin. “Diabetic-friendly” foods that cost twice as much but barely made a difference.</p>
                    <p>Every meal, every craving, every pill… all part of a system I didn’t choose, just got trapped in.</p>
                    <p>The rules were always the same:<br />Don’t eat that. Don’t touch this. Count every carb. Fear every bite.</p>
                    <p>And yet, this morning, I had pancakes.<br />Drenched in maple syrup. Fluffy, golden, perfect.</p>
                </div>
                <div className="col-xxl-4 col-lg-5 col-md-6 col-12 mt-md-0 mt-1 align-items-center text-center order-md-2 order-1">
                    <picture>
                        <source srcSet={pancakeLandscapeImgWebp} type="image/webp" />
                        <img className="img-fluid gg-border-radius" src={pancakeLandscapeImg} loading="lazy" />
                    </picture>
                </div>
            </div>
        </div>
    </section>
);

export default DiabeticCustomer;